/* eslint-disable camelcase */
import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import { EmbedWrapper, FlexBox } from '@/styles/index';
import { fetchServerPollBySlug } from '@/utils/data';
// import useSWR from 'swr';
// import { fetchServerPollBySlug, axiosFetcher } from '@/utils/data';
import HeadMeta from '@/components/HeadMeta';

// import Poll from '@/components/Poll';
// import PollSkeleton from '@/components/Poll/Skeleton';
const Poll = dynamic(() => import('@/components/Poll'));
const PollSkeleton = dynamic(() => import('@/components/Poll/Skeleton'));

// export async function getServerSideProps(req, res) {
//   const { params } = req;
//   if (!params.slug) {
//     return {
//       props: {} // will be passed to the page component as props
//     };
//   }
//   if (params.slug.length > 10) {
//     // new poll slugs has 10 char
//     return {
//       props: {} // will be passed to the page component as props
//     };
//   }
//   // params contains the poll `slug`.
//   // If the route is like /poll/1, then params.slug is 1
//   try {
//     const { data } = await fetchServerPollBySlug({ slug: params.slug });
//     if (!data) {
//       return {
//         props: {} // will be passed to the page component as props
//       };
//     }
//     return {
//       props: { poll: data } // Pass poll data to the page via props
//       // Next.js will attempt to re-generate the page:
//       // - When a request comes in
//       // - At most once every second
//       // revalidate: 1 // In seconds
//     };
//   } catch (error) {
//     console.error(error);
//     return {
//       props: {} // will be passed to the page component as props
//     };
//   }
// }

// CHECK
// https://static-tweet.vercel.app/

// This function gets called at build time
export async function getStaticPaths() {
  return { paths: [], fallback: true };
}

// This also gets called at build time
export async function getStaticProps(req, res) {
  const { params } = req;
  if (!params.slug) {
    return { notFound: true };
  }
  // if (params.slug.length > 10) {
  //   // new poll slugs has 10 char
  //   return { notFound: true };
  // }
  // params contains the poll `slug`.
  // If the route is like /poll/1, then params.slug is 1
  try {
    const { data } = await fetchServerPollBySlug({ slug: params.slug });
    return data
      ? {
          props: { poll: data }, // Pass poll data to the page via props
          // Next.js will attempt to re-generate the page:
          // - When a request comes in
          // - At most once every second
          revalidate: 1 // In seconds
        }
      : { notFound: true };
  } catch (error) {
    console.error(error);
    return { notFound: true };
  }
}

const PollEmbed = ({ poll, router }) => {
  // console.log({ router });
  const [loading, setLoading] = useState(true);
  // const [model, setModel] = useState(null);
  const [model, setModel] = useState(poll ? JSON.parse(poll.model) : null);
  const [error, setError] = useState(null);
  // const { slug } = router.query;
  // console.log({ slug, poll });
  // // https://swr.vercel.app/docs/arguments
  // const { data, error, mutate } = useSWR(
  //   [`/api/poll/${slug}`, JSON.stringify({})],
  //   (url, options) => {
  //     if (!slug) {
  //       return <div />;
  //     }
  //     return axiosFetcher(url, JSON.parse(options));
  //   }
  // );

  // const pollData = data?.data;
  // console.log({ pollData });
  useEffect(() => {
    // console.log({ data });
    if (poll) {
      // console.log({ data });
      const pollModel = poll.model;
      // console.log({ pollMode });
      setModel(pollModel ? JSON.parse(pollModel) : {});
      setLoading(false);
      setError(null);
    }
    // if (!pollData) {
    //   setLoading(false);
    //   setError({ error: 'No poll found' });
    // }
  }, [poll]);

  const defaultValues = { ...router?.query };
  delete defaultValues.slug;
  // console.log({ defaultValues });

  return (
    <EmbedWrapper>
      <HeadMeta
        title={poll ? `${poll.title} – Pollme` : null}
        description={poll ? poll.description : null}
        robots="noindex, nofollow"
      >
        <link
          rel="alternate"
          type="application/json+oembed"
          href={`https://pollme.app/api/services/oembed?url=https://pollme.app/embed/${poll.slug}`}
          title={poll.title}
        />
      </HeadMeta>
      <FlexBox>
        {[router.isFallback, loading, error].some(Boolean) ? (
          <div className="loading-poll-wrapper">
            {router.isFallback || (loading && <PollSkeleton embedded />)}
            {error && <div>Some error ocurred, please reload</div>}
          </div>
        ) : (
          <Poll poll={poll} model={model} defaultValues={defaultValues} embedded />
        )}
      </FlexBox>
    </EmbedWrapper>
  );
};

const EmbedDataWrapper = props => {
  const { poll } = props;
  // check if user has active subscription
  const premiumUser = poll?.premiumUser;
  const [checkingIframe, setCheckingIFrame] = useState(true);
  const router = useRouter();
  // https://stackoverflow.com/questions/326069/how-to-identify-if-a-webpage-is-being-loaded-inside-an-iframe-or-directly-into-t
  // console.log(window)
  // if (window.location !== window.parent.location ) {
  //   // The page is in an iframe
  //   // should do nothing
  // } else {
  //   // The page is not in an iframe
  //   // if not on iframe, redirect to single poll page /p/[slug]
  // }

  useEffect(() => {
    function inIframe() {
      try {
        // access to window.top will cause cross-origin error on external sites, triggering the catch, meaning is on iframe
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    }
    if (router) {
      const { slug } = router.query;
      const isInIframe = inIframe();
      // console.log({ isInIframe, slug });
      // if not on iframe, replace url
      if (!isInIframe) {
        router.replace(`/p/${slug}`);
      } else {
        setCheckingIFrame(false);
      }
    }
  }, [router]);

  // console.log({ poll });
  if (!router || checkingIframe) {
    return <PollSkeleton simple embedded />;
  }

  if (router.isFallback) {
    return <PollSkeleton simple embedded />;
  }
  if (!poll) {
    return <PollSkeleton simple error="No poll found" embedded />;
  }
  // if not premium user
  if (!premiumUser) {
    return (
      <PollSkeleton simple error="Poll cannot be embedded. User cannot embed polls" embedded />
    );
  }
  // poll status checks
  if (poll.status === 'paused') {
    return <PollSkeleton simple error="Poll is paused" embedded />;
  }
  // cannot redirect on embedded card
  if (poll.status === 'unpublished') {
    return <PollSkeleton simple error="Unpublished poll" embedded />;
  }
  return <PollEmbed {...props} router={router} />;
};
export default EmbedDataWrapper;

EmbedDataWrapper.omitSession = true;
EmbedDataWrapper.omitProgress = true;
